import React, { useState } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton, Popover, Typography } from '@mui/material';

// Popup component for info icon in email section

const InfoPopup = ({style}) => {
  const [anchor, setAnchor] = useState(null);

  const handleToggle = (event) => {
    setAnchor(anchor ? null : event.currentTarget);
  };


  return (
    <div style={style}>
      <IconButton 
        onClick={handleToggle} 
        disableRipple 
        style={{ padding: 2}}
        sx={{
            padding: 0,
            '&:hover svg': {
            transform: 'scale(1.15)',
            },
            '& svg': {
            transition: 'transform 0.05s ease',
            transformOrigin: 'center',
            }
        }}>
        <InfoOutlinedIcon style={{ fontSize: 24, color: '#000000' }} />
      </IconButton>

      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}        
      >
        <Typography sx={{ p: 2, maxWidth: 280, fontSize: '16px', fontFamily: 'Finlandica-Regular, sans-serif', lineHeight: '20px', color: '#000000' }}>
          Muokkaa lipun käyttäjän sähköpostiosoite sähköpostikenttään tai tyhjennä kenttä. Tämän jälkeen paina "Tallenna muutokset". 
        </Typography>
      </Popover>
    </div>
  );
};

export default InfoPopup;

